export const mathematicsData = {
  departmentName: "Department of Mathematics",
  bannerImage: "/infrastructure/mathematics/class-2.JPG", // Full width banner image
  
  about: {
    title: "About the Department",
    content: `The Department of Mathematics at Rayalaseema University is committed to excellence in mathematical education and research. 
    Established with a vision to foster analytical thinking and problem-solving skills, the department offers comprehensive programs 
    in pure and applied mathematics. Our faculty members are dedicated researchers contributing to various fields including algebra, 
    analysis, differential equations, and mathematical modeling.`,
    highlights: [
      "State-of-the-art computational facilities",
      "Research collaborations with national and international institutions",
      "Regular seminars and workshops",
      "Strong placement record in academics and industry"
    ]
  },

  brochure: {
    title: "Department Brochure",
    pdfLink: "/mathematics/department-brochure.pdf",
    description: "Download our comprehensive department brochure for detailed information about programs, facilities, and achievements."
  },

  hod: {
    name: "Prof. Venkata Sundaranand Putcha",
    designation: "Professor & Head",
    photo: "/mathematics/putcha1.JPG",
    email: "anand_putcha@yahoo.com",
    mobile: "9848226855",
    qualification: "M.Sc., Ph.D.",
     specialization: "Nonlinear, Dynamics Cryptology, Fuzzy Control",
    message: `Welcome to the Department of Mathematics at Rayalaseema University. We are dedicated to nurturing mathematical 
    talent and fostering a culture of research and innovation. Our department strives to provide quality education that prepares 
    students for successful careers in academia, research, and industry.`,
    profileLink: "/mathematics/VENKATA-SUNDARANAND-PUTCHA.pdf"
  },

  bos: {
  title: "Mathematics",
  members: [
    {
      name: "Prof. Venkata Sundaranand Putcha",
      designation: "Chairperson",
      affiliation: "Dept. of Mathematics, Rayalaseema University, Kurnool"
    },
    {
      name: "Prof. K. Rajendra Prasad",
      designation: "Member",
      affiliation: "Dept. of Mathematics, Andhra University, Visakhapatnam"
    },
    {
      name: "Prof. D. Bharathi",
      designation: "Member",
      affiliation: "Dept. of Mathematics, S.V. University, Tirupati"
    },
    {
      name: "Prof. A.S.V. Ravi Kanth",
      designation: "Member",
      affiliation: "Dept. of Mathematics, NIT, Kurukshetra"
    },
    {
      name: "Prof. G. Kathyayani",
      designation: "Member",
      affiliation: "Dept. of Mathematics, Yogi Vemana University, Kadapa"
    },
    {
      name: "Prof. G.V.S.R. Deekshithulu",
      designation: "Member",
      affiliation: "Dept. of Mathematics, JNTUK, Kakinada"
    },
    {
      name: "Dr. G. Sitaramabrahmam",
      designation: "Member",
      affiliation: "Senior Consultant, Tata Consultancy Services Ltd., Madhapur, Hyderabad"
    }
  ]
}
,

  faculty: [
    {
      id: "math001",
      name: "Prof. Venkata Sundaranand Putcha",
      designation: "Professor & Head",
      email: "anand_putcha@yahoo.com",
      mobile: "9848226855",
      photo: "/mathematics/putcha1.jpg",
      qualification: "M.Sc., Ph.D.",
      specialization: "Nonlinear, Dynamics Cryptology, Fuzzy Control",
      profileLink: "/mathematics/VENKATA-SUNDARANAND-PUTCHA.pdf"
    },
    // {
    //   id: "math002",
    //   name: "Dr. M. Veera Krishna",
    //   designation: "Assistant Professor (C)",
    //   email: "veerakrishna_maths@yahoo.com",
    //   mobile: "9849650682",
    //   photo: "/mathematics/veerakrishna.JPG",
    //   qualification: "M.Sc., MPhil., PhD.,APSET",
    //   specialization: "Fluid Dynamics, Heat Transfer",
    //   profileLink: "/mathematics/M-VEERA-KRISHNA.pdf"
    // },
    {
      id: "math003",
      name: "Dr. S.V. Suneetha",
      designation: "Assistant Professor (C)",
      email: "sunithaknl17@gmail.com",
      mobile: "9866945663",
      photo: "/mathematics/sunnetha.JPG",
      qualification: "M.Sc., MPhil., PhD.",
      specialization: "Operations Research, Optimization",
      profileLink: "/mathematics/SV-SUNEETHA.pdf"
    },
    {
      id: "math004",
      name: "Dr. U. Nagi Reddy",
      designation: "Assistant Professor (C)",
      email: "nagireddyppr@gmail.com",
      mobile: "8106415164",
      photo: "/mathematics/Nagireddy.JPEG",
      qualification: "M.Sc., M.Phil, Ph.D.,APSET",
      specialization: "Functional Analysis, Topology",
      profileLink: "/mathematics/U-NAGI-REDDY.pdf"
    }
  ],

  courses: {
    // undergraduate: [
    //   {
    //     name: "B.Sc. Mathematics",
    //     duration: "3 Years",
    //     eligibility: "10+2 with Mathematics",
    //     intake: "60 seats"
    //   }
    // ],
    postgraduate: [
      {
        name: "M.Sc. Mathematics",
        duration: "2 Years",
        eligibility: "B.Sc. with Mathematics",
        intake: "30 seats"
      }
    ],
    research: [
      {
        name: "Ph.D. in Mathematics",
        duration: "Minimum 3 Years",
        eligibility: "M.Sc. Mathematics with qualifying exam",
        areas: "Algebra, Analysis, Differential Equations, Topology, Applied Mathematics"
      }
    ]
  },

  Infrastructure: [
  "/infrastructure/mathematics/class-1.JPG",
  "/infrastructure/mathematics/class-2.JPG",
  
]
};
